import { ATP_API_URL } from "../config/apiConfig";
import { getAuthToken } from "../utils/index";
import axios from "axios";

export const uploadDocumentAction = async ({
    file,
    documentRequirementId,
    entityId,
    entityDocumentId,
    onProgress,
}) => {
    try {
        const token = getAuthToken();

        const formData = new FormData();

        // Match the exact order from the cURL command
        formData.append("EntityDocumentId", entityDocumentId || 0);
        formData.append("DocumentRequirementId", documentRequirementId);
        formData.append("EntityId", entityId);
        formData.append("File", file);

        const headers = {
            "Content-Type": "multipart/form-data",
        };

        if (token) {
            headers["Authorization"] = `Bearer ${token}`;
        }

        const response = await axios.post(ATP_API_URL.UPLOAD_DOCUMENT, formData, {
            headers,
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                if (onProgress) {
                    onProgress(percentCompleted);
                }
            },
        });

        return {
            success: true,
            data: response.data,
            message: "Document uploaded successfully",
        };
    } catch (error) {
        let errorMessage = "Failed to upload document";

        if (error.response?.status === 403) {
            errorMessage = "Access denied. Please ensure you have permission to upload documents.";
        } else if (error.response?.status === 401) {
            errorMessage = "Authentication required. Please login to upload documents.";
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        return {
            success: false,
            error: errorMessage,
            statusCode: error.response?.status,
            details: error.response?.data
        };
    }
};
